import { statusText, latenessCell, oeeCell } from "./production-order-utils";
import type { ProductionOrder } from "../../types/production-orders.types.js";

// CSV das OPs carregadas (delimitador ';'; BOM aplicado por downloadCsv).
function csvCell(v: string | number): string {
  const s = String(v);
  return /[",\n;]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCsv(items: ProductionOrder[]): string {
  const header = [
    "Código",
    "Linha",
    "Produtos",
    "Status",
    "Início",
    "Fim",
    // O prazo sai em ISO (como Início/Fim, para planilha/ERP reprocessar) e o atraso
    // no rótulo legível da tela — CSV e UI contam a MESMA história.
    "Prazo",
    "Atraso",
    "Qtd",
    "Responsável",
    "OEE",
  ];
  const rows = items.map((o) =>
    [
      o.code ?? "",
      o.lineName,
      o.products.map((p) => p.name).join(" / "),
      statusText(o),
      o.plannedStartAt,
      o.expectedEnd,
      o.dueDate ?? "",
      latenessCell(o),
      o.plannedQty,
      o.responsible ?? "",
      oeeCell(o),
    ]
      .map(csvCell)
      .join(";")
  );
  return [header.join(";"), ...rows].join("\n");
}
